// Форматирование для статистики и себестоимости по пользователям (админка).

const FEATURE_LABELS = {
  enrichment: 'Тональность и сущности сообщений',
  story_clustering: 'Группировка сообщений в сюжеты',
  qlang_generation: 'Генерация запросов проекта',
  report_summary: 'Сводка в отчётах',
  web_source_detection: 'Разбор страниц веб-источников',
  source_geolocation: 'География источников',
  source_topic: 'Разделы каналов',
  other: 'Прочее'
}

export function featureLabel(feature) {
  return FEATURE_LABELS[feature] || feature
}

export function formatNumber(value) {
  return (value || 0).toLocaleString('ru-RU')
}

export function formatMoney(value, digits = 2) {
  return (value || 0).toLocaleString('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export function formatBytes(bytes) {
  if (!bytes) return '0'
  const units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ']
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  const value = bytes / Math.pow(1024, index)
  return value.toLocaleString('ru-RU', { maximumFractionDigits: index === 0 ? 0 : 1 }) + ' ' + units[index]
}
